import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';


export const SellerPolicies = () => {
  const [agreed,   setAgreed]   = useState(false);
  const [signed,   setSigned]   = useState(false);
  const [submitting,setSubmitting]=useState(false);
  const [done,     setDone]     = useState(false);
  const canvasRef = useRef(null);
  const [drawing,  setDrawing]  = useState(false);

  const seller = JSON.parse(localStorage.getItem('seller_user')||'{}');

  const startDraw = (e) => {
    setDrawing(true);
    const c = canvasRef.current; const ctx = c.getContext('2d');
    const r = c.getBoundingClientRect();
    ctx.beginPath(); ctx.moveTo(e.clientX-r.left, e.clientY-r.top);
    setSigned(true);
  };
  const draw = (e) => {
    if (!drawing) return;
    const c = canvasRef.current; const ctx = c.getContext('2d');
    const r = c.getBoundingClientRect();
    ctx.lineWidth=2; ctx.strokeStyle='#10b981'; ctx.lineCap='round';
    ctx.lineTo(e.clientX-r.left, e.clientY-r.top); ctx.stroke();
  };
  const stopDraw = () => setDrawing(false);

  const handleAgree = async () => {
    if (!agreed) { alert('Please read and check the agreement box.'); return; }
    if (!signed) { alert('Please sign in the signature area below.'); return; }
    setSubmitting(true);
    try {
      await profileAPI.agreePolicies();
    } catch { /* proceed anyway */ }
    setDone(true);
    setSubmitting(false);
  };

  if (done) return (
    <div className="sp-card" style={{textAlign:'center',padding:'3rem'}}>
      <div style={{fontSize:'3rem',marginBottom:'1rem'}}>✅</div>
      <h2 style={{fontFamily:'var(--fd)',color:'var(--em-300)',marginBottom:'0.5rem'}}>Agreement Signed!</h2>
      <p style={{color:'var(--t2)',fontSize:14}}>Thank you, {seller.firstName}. Your seller agreement is digitally signed and recorded.</p>
    </div>
  );

  return (
    <div>
      <div className="sp-card" style={{marginBottom:'1.25rem'}}>
        <div className="sp-card-title">Seller Terms & Policies</div>
        <div className="sp-policy-scroll">
          <h3>1. Seller Eligibility</h3>
          <p>To sell on ATR Agro Mart, you must be a registered business or individual farmer operating legally within India. You must provide accurate PAN and GST information where applicable.</p>
          <h3>2. Product Listing Standards</h3>
          <p>All products listed must be genuine, accurately described, and comply with FSSAI standards where applicable. Misleading descriptions, counterfeit goods, or prohibited items will result in immediate account suspension.</p>
          <h3>3. Pricing & Commissions</h3>
          <p>ATR Agro Mart charges zero commission for the first 3 months. After the trial period, a standard platform fee of 5–8% applies based on product category. Pricing must be transparent and inclusive of applicable taxes.</p>
          <h3>4. Order Fulfillment</h3>
          <p>Sellers are responsible for packaging and handing over orders within 24 hours of placement. ATR's logistics partners handle last-mile delivery. Failure to fulfill orders regularly may result in account penalties.</p>
          <h3>5. Returns & Refunds</h3>
          <p>Customers may raise return requests within 7 days. Sellers must review and respond within 48 hours. Approved refunds are debited from the seller's wallet balance.</p>
          <h3>6. Payment Settlement</h3>
          <p>Earnings are settled every Monday and Thursday. The minimum withdrawal amount is ₹100. Settlements are made to the verified bank account on file.</p>
          <h3>7. Data & Privacy</h3>
          <p>ATR Agro Mart collects seller business data solely for platform operations. We do not sell seller data to third parties. Sellers retain ownership of their product listings and content.</p>
          <h3>8. Account Termination</h3>
          <p>ATR reserves the right to suspend or terminate accounts that violate these terms. Sellers may also close their account with 30 days' notice, ensuring all pending orders are fulfilled.</p>
          <h3>9. Governing Law</h3>
          <p>These terms are governed by the laws of India. Disputes shall be resolved in the courts of Madurai, Tamil Nadu.</p>
        </div>
      </div>

      <div className="sp-card">
        <div className="sp-policy-agree-row">
          <input type="checkbox" className="sp-policy-checkbox" id="agree-chk" checked={agreed} onChange={e => setAgreed(e.target.checked)} />
          <label htmlFor="agree-chk">I, <b>{seller.firstName} {seller.lastName}</b>, have read, understood and agree to the ATR Agro Mart <b>Seller Terms & Policies</b>. I confirm that all information I provide is accurate.</label>
        </div>

        <div className="sp-label" style={{marginBottom:'0.5rem'}}>DIGITAL SIGNATURE</div>
        <canvas ref={canvasRef} width={400} height={100} className={`sp-sign-area ${signed?'signed':''}`} style={{display:'block',cursor:'crosshair',touchAction:'none'}}
          onMouseDown={startDraw} onMouseMove={draw} onMouseUp={stopDraw} onMouseLeave={stopDraw} />
        <div style={{display:'flex',gap:'0.5rem',marginBottom:'1rem'}}>
          <p style={{fontSize:11,color:'var(--t3)',flex:1}}>Draw your signature above</p>
          <button style={{fontSize:11,color:'var(--t3)',background:'none',cursor:'pointer',border:'1px solid var(--border)',borderRadius:'var(--r-sm)',padding:'2px 8px'}} onClick={() => { canvasRef.current?.getContext('2d')?.clearRect(0,0,400,100); setSigned(false); }}>Clear</button>
        </div>

        <button className="sp-btn-primary" style={{padding:'0.85rem 2rem'}} onClick={handleAgree} disabled={submitting}>
          {submitting ? 'Processing…' : '✍️ Sign & Agree to Terms'}
        </button>
      </div>
    </div>
  );
};

export default SellerPolicies;